import { Route, createBrowserRouter, createRoutesFromElements } from "react-router-dom";
import MainLayout from "./MainLayout";
import MainUI from "./MainUI";





const MainRouter = (Finance, inventory, contacts, purchaseRouter, salesRouter, mainRouter, employeeRouter, expenseRouter, access_right) => {
  const router = createBrowserRouter(
    createRoutesFromElements(
      <>
        <Route path="/" element={<MainLayout />}>
          <Route index element={<MainUI />} />
          {access_right && access_right.accounting_role &&  Finance() }
          {access_right && access_right.inventory_role && inventory() }
          { contacts() }
          {access_right && access_right.purchase_role && purchaseRouter() }
          {access_right && access_right.sales_role && salesRouter() }
          {access_right && access_right.settings === 1 && mainRouter() }
          {access_right && access_right.employee_role && employeeRouter() }
          {access_right && access_right.expense_role && expenseRouter() }
        </Route>  
      </>
    )
  );

  return router;
}


export default MainRouter;